import { Redirect, useLocalSearchParams } from 'expo-router'
import { VoiceAssessmentFlow } from '@/src/features/voice-assessment/components/VoiceAssessmentFlow'
import { parseBackendSessionIdParam } from '@/src/features/voice-assessment/utils/voice-assessment-route'

export default function VoiceAssessmentRoute() {
  const { sessionId, source } = useLocalSearchParams<{
    sessionId?: string | string[]
    source?: string | string[]
  }>()
  const backendSessionId = parseBackendSessionIdParam(sessionId)
  const rawSource = Array.isArray(source) ? source[0] : source
  const isOnboardingEntry = rawSource === 'onboarding'

  if (backendSessionId == null) {
    return <Redirect href="/(protected)/(account)/(tabs)" />
  }

  return (
    <VoiceAssessmentFlow
      key={`session-${backendSessionId}`}
      backendSessionId={backendSessionId}
      isOnboardingEntry={isOnboardingEntry}
    />
  )
}
